/* Cyber Days EXTENDIDO hasta el domingo 11 de octubre 2026.
   Este tema es la version que se publica el 7 a las 00:00, cuando se anuncia la extension.
   El tema sin "(EXTENDIDA)" en el nombre es el que termina el martes 7: no mezclarlos. */
(function () {
  'use strict';

  var FIN   = new Date('2026-10-12T00:00:00-03:00');  // se acaba al terminar el domingo 11 (23:59)

  function dos(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------- contador ---------- */
  function tic() {
    var caja = document.querySelector('.cy-reloj');
    if (!caja) return;
    var s = Math.floor(Math.max(0, FIN - new Date()) / 1000);
    var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
    caja.querySelectorAll('b').forEach(function (b, i) {
      var n = dos(v[i]);
      if (b.textContent !== n) b.textContent = n;
    });
  }

  /* El sello ya NO se pone por JS: lo pinta `snippets/card-product.liquid` cuando el
     producto tiene el tag `cyber`. Asi es exacto (no se adivina por el descuento),
     sale ya dibujado sin parpadeo, y sobrevive al filtrar o paginar sin observadores. */

  /* ---------- burbuja en el telefono ----------
     Al bajar, la barra se encoge y se va arriba a la derecha para no taparle el buscador
     al header fijo. Como pasa a position:fixed sale del flujo, asi que se deja un hueco
     del mismo alto para que el contenido no salte. */
  var LIMITE = 150;                 // px de scroll antes de encoger
  var movil = window.matchMedia('(max-width: 749px)');
  var barra, hueco, pedido = false;

  function ubicar() {
    /* la burbuja se cuelga justo debajo del header fijo; el alto se mide, no se adivina */
    var cab = document.querySelector('sticky-header') ||
              document.querySelector('.section-header') ||
              document.getElementById('shopify-section-header');
    var abajo = cab ? cab.getBoundingClientRect().bottom : 0;
    barra.style.setProperty('--cy-top', Math.max(8, Math.round(abajo) + 8) + 'px');
  }

  function revisar() {
    pedido = false;
    if (!barra) return;
    var encoger = movil.matches && window.pageYOffset > LIMITE;
    if (encoger && !barra.classList.contains('cy-burbuja')) {
      hueco.style.height = barra.offsetHeight + 'px';
      hueco.classList.add('cy-activo');
      barra.classList.add('cy-burbuja');
    } else if (!encoger && barra.classList.contains('cy-burbuja')) {
      barra.classList.remove('cy-burbuja');
      hueco.classList.remove('cy-activo');
    }
    if (encoger) ubicar();
  }

  function alScroll() {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(revisar);
  }

  function burbuja() {
    barra = document.querySelector('.cy-barra');
    if (!barra) return;
    hueco = document.createElement('div');
    hueco.className = 'cy-hueco';
    barra.parentNode.insertBefore(hueco, barra.nextSibling);
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    revisar();
  }

  /* ---------- entrada escalonada ---------- */
  function entradas() {
    if (!('IntersectionObserver' in window)) return;
    var ob = new IntersectionObserver(function (filas) {
      filas.forEach(function (f, i) {
        if (!f.isIntersecting) return;
        setTimeout(function () { f.target.classList.add('cy-ya'); }, i * 55);
        ob.unobserve(f.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      c.classList.add('cy-entra'); ob.observe(c);
    });
  }

  function iniciar() {
    tic();
    setInterval(tic, 1000);
    burbuja();
    entradas();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
